<template>
  <div class="nav-left-drawer mdl-layout__drawer mdl-color--blue-grey-900 mdl-color-text--blue-grey-50">
    <header class="nav-left-drawer-header" v-if="authenticated">
        <img :src="gravatar" class="nav-left-avatar">
        <div class="nav-left-avatar-dropdown">
        <span>{{username}}</span>
        <div class="mdl-layout-spacer"></div>
        <div class="mdl-menu__container is-upgraded"><div class="mdl-menu__outline mdl-menu--bottom-right"></div><ul class="mdl-menu mdl-menu--bottom-right mdl-js-menu mdl-js-ripple-effect mdl-js-ripple-effect--ignore-events" for="accbtn" data-upgraded=",MaterialMenu,MaterialRipple">
            <li class="mdl-menu__item mdl-js-ripple-effect" tabindex="-1" data-upgraded=",MaterialRipple">hello@example.com<span class="mdl-menu__item-ripple-container"><span class="mdl-ripple"></span></span></li>
            <li class="mdl-menu__item mdl-js-ripple-effect" tabindex="-1" data-upgraded=",MaterialRipple">info@example.com<span class="mdl-menu__item-ripple-container"><span class="mdl-ripple"></span></span></li>
            <li class="mdl-menu__item mdl-js-ripple-effect" tabindex="-1" data-upgraded=",MaterialRipple"><i class="material-icons">add</i>Add another account...<span class="mdl-menu__item-ripple-container"><span class="mdl-ripple"></span></span></li>
        </ul></div>
        </div>
    </header>
    <nav class="nav-left-navigation mdl-navigation mdl-color--blue-grey-800">
        <a class="mdl-navigation__link" href=""><i class="mdl-color-text--blue-grey-400 material-icons" role="presentation">home</i>Home</a>
        <a class="mdl-navigation__link" href=""><i class="mdl-color-text--blue-grey-400 material-icons" role="presentation">inbox</i>Inbox</a>
        <a class="mdl-navigation__link" href=""><i class="mdl-color-text--blue-grey-400 material-icons" role="presentation">delete</i>Trash</a>
        <a class="mdl-navigation__link" href=""><i class="mdl-color-text--blue-grey-400 material-icons" role="presentation">report</i>Spam</a>
        <a class="mdl-navigation__link" href=""><i class="mdl-color-text--blue-grey-400 material-icons" role="presentation">forum</i>Forums</a>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'NavLeft',
  computed: {
    authenticated () {
      return this.$store.state.user.authenticated
    },
    username () {
      return this.$store.state.user.username || this.$store.state.user.newUser
    },
    gravatar () {
      var email = this.$store.state.user.username || this.$store.state.user.newUser
      return (email) ? getGravatar(email, 48) : null
    }
  }
}

function getGravatar (email, size) {
  var CryptoJS = require('crypto-js')
  size = size || 80
  return 'http://www.gravatar.com/avatar/' + CryptoJS.MD5(email) + '.jpg?s=' + size
}
</script>

<style lang="scss" scoped>

  .nav-left-avatar {
    width: 48px;
    height: 48px;
    border-radius: 24px;
  }
  .nav-left-layout .mdl-layout__header .mdl-layout__drawer-button {
    color: rgba(0, 0, 0, 0.54);
  }
  .mdl-layout__drawer .avatar {
    margin-bottom: 16px;
  }
  .nav-left-drawer {
    border: none;
    overflow: visible;
  }
  /* iOS Safari specific workaround */
  .nav-left-drawer .mdl-menu__container {
    z-index: -1;
  }
  .nav-left-drawer .nav-left-navigation {
    z-index: -2;
  }
  /* END iOS Safari specific workaround */
  .nav-left-drawer .mdl-menu .mdl-menu__item {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-align-items: center;
        -ms-flex-align: center;
            align-items: center;
  }
  .nav-left-drawer-header {
    box-sizing: border-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-justify-content: flex-end;
        -ms-flex-pack: end;
            justify-content: flex-end;
    padding: 16px;
    height: 151px;
  }
  .nav-left-avatar-dropdown {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    position: relative;
    -webkit-flex-direction: row;
        -ms-flex-direction: row;
            flex-direction: row;
    -webkit-align-items: center;
        -ms-flex-align: center;
            align-items: center;
    width: 100%;
  }

  .nav-left-navigation {
    -webkit-flex-grow: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
  }
  .nav-left-layout .nav-left-navigation .mdl-navigation__link {
    display: -webkit-flex !important;
    display: -ms-flexbox !important;
    display: flex !important;
    -webkit-flex-direction: row;
        -ms-flex-direction: row;
            flex-direction: row;
    -webkit-align-items: center;
        -ms-flex-align: center;
            align-items: center;
    color: rgba(255, 255, 255, 0.56);
    font-weight: 500;
  }
  .nav-left-layout .nav-left-navigation .mdl-navigation__link:hover {
    background-color: #00BCD4;
    color: #37474F;
  }
  .nav-left-navigation .mdl-navigation__link .material-icons {
    font-size: 24px;
    color: rgba(255, 255, 255, 0.56);
    margin-right: 32px;
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/NavLeft.vue